import React from "react";
import { Link } from "react-router-dom";
import DomainNavLink from "./DomainNavLink";
import { Instagram, Youtube } from "lucide-react";

export const INSTAGRAM_URL = "https://www.instagram.com/constelabrasiloficial";
export const YOUTUBE_URL =
  "https://youtube.com/@constelabrasiloficial?si=u-ibds6AHScu_nOa";
export const WHATSAPP_URL =
  "https://api.whatsapp.com/send/?phone=5513997701755&text=Ola";

const Footer: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#3A5859] py-12 text-white">
      <div className="mx-auto max-w-6xl px-4 text-center sm:px-6 lg:px-8">
        <div className="mb-6 flex flex-wrap items-center justify-center gap-6">
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-white/80 transition-colors hover:text-white"
            aria-label="Instagram @constelabrasiloficial"
          >
            <Instagram className="h-5 w-5" />
            @constelabrasiloficial
          </a>
          <a
            href={YOUTUBE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-white/80 transition-colors hover:text-white"
            aria-label="Canal YouTube Constela Brasil"
          >
            <Youtube className="h-5 w-5" />
            YouTube
          </a>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-white/80 transition-colors hover:text-white"
            aria-label="WhatsApp Constela Brasil"
          >
            WhatsApp
          </a>
        </div>
        <div className="mb-4 flex flex-wrap justify-center gap-6">
          <Link
            to="/sobre-nos"
            className="text-white/80 transition-colors hover:text-white hover:underline"
          >
            Sobre Nós
          </Link>
          <Link
            to="/politica-de-privacidade"
            className="text-white/80 transition-colors hover:text-white hover:underline"
          >
            Política de Privacidade
          </Link>
          <Link
            to="/termos-de-servico"
            className="text-white/80 transition-colors hover:text-white hover:underline"
          >
            Termos de Serviço
          </Link>
          <DomainNavLink
            to="/terapeutas?oferta=social"
            className="text-white/80 transition-colors hover:text-white hover:underline"
          >
            Projeto social
          </DomainNavLink>
          <Link
            to="/contato"
            className="text-white/80 transition-colors hover:text-white hover:underline"
          >
            Contato
          </Link>
        </div>
        <p className="text-sm text-white/60">
          Constela Brasil © {year} · Todos os direitos reservados
        </p>
      </div>
    </footer>
  );
};

export default Footer;
